const MistralAI = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid"
        viewBox="0 0 256 233"
        width="1em"
        height="1em"
        {...props}
    >
        <title>Mistral AI</title>
        <path d="M186.18182 0h46.54545v46.54545h-46.54545z" />
        <path fill="#F7D046" d="M209.45454 0h46.54545v46.54545h-46.54545z" />
        <path d="M0 0h46.54545v46.54545H0zM0 46.54545h46.54545V93.0909H0zM0 93.09091h46.54545v46.54545H0zM0 139.63636h46.54545v46.54545H0zM0 186.18182h46.54545v46.54545H0z" />
        <path fill="#F7D046" d="M23.27273 0h46.54545v46.54545H23.27273z" />
        <path
            fill="#F2A73B"
            d="M209.45454 46.54545h46.54545V93.0909h-46.54545zM23.27273 46.54545h46.54545V93.0909H23.27273z"
        />
        <path d="M139.63636 46.54545h46.54545V93.0909h-46.54545z" />
        <path
            fill="#F2A73B"
            d="M162.90909 46.54545h46.54545V93.0909h-46.54545zM69.81818 46.54545h46.54545V93.0909H69.81818z"
        />
        <path
            fill="#EE792F"
            d="M116.36364 93.09091h46.54545v46.54545h-46.54545zM162.90909 93.09091h46.54545v46.54545h-46.54545zM69.81818 93.09091h46.54545v46.54545H69.81818z"
        />
        <path d="M93.09091 139.63636h46.54545v46.54545H93.09091z" />
        <path
            fill="#EB5829"
            d="M116.36364 139.63636h46.54545v46.54545h-46.54545z"
        />
        <path
            fill="#EE792F"
            d="M209.45454 93.09091h46.54545v46.54545h-46.54545zM23.27273 93.09091h46.54545v46.54545H23.27273z"
        />
        <path d="M186.18182 139.63636h46.54545v46.54545h-46.54545z" />
        <path
            fill="#EB5829"
            d="M209.45454 139.63636h46.54545v46.54545h-46.54545z"
        />
        <path d="M186.18182 186.18182h46.54545v46.54545h-46.54545z" />
        <path
            fill="#EB5829"
            d="M23.27273 139.63636h46.54545v46.54545H23.27273z"
        />
        <path
            fill="#EA3326"
            d="M209.45454 186.18182h46.54545v46.54545h-46.54545zM23.27273 186.18182h46.54545v46.54545H23.27273z"
        />
    </svg>
);
export default MistralAI;
